jQuery(function($){

	if(typeof $('.slide-banner').slick !== "undefined") {

		$('.slide-banner').slick({
			dots: true,
			arrows: false,
			autoplay: true,
			infinite: true,
			speed: 800,
			autoplaySpeed: 5000,
			pauseOnDotsHover: true,
			cssEase: 'linear',
			fade: true,
		});
	}
});